var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
export var LoadingRoot = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & path {\n    stroke: ", ";\n  }\n"])), function (props) {
  return props.color;
});